<!--
 * @Description: 聊天框大组件
 * @Date: 2019-10-24 10:58:17
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 16:00:57
 -->
<template>
  <v-card class="mx-auto home">
    <v-content class>
      <!-- 患者列表页头 -->
      <div class="r_">
        <v-app-bar color="indigo darken-1" dark>
          <v-menu right bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-app-bar-nav-icon></v-app-bar-nav-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="n in doctorSetting" :key="n.icon" @click="doctor( n.name )">
                <v-list-item-title> <v-icon>{{ n.icon }} </v-icon> {{ n.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- <v-toolbar-title>Page title</v-toolbar-title> -->
          <v-spacer></v-spacer>
          <v-col cols="12" sm="9" md="9" class="input_">
            <v-text-field
              label="搜索患者"
              dense
              v-model="value"
              clearable
              flat
              solo-inverted
              hide-details
              @input="oneList__"
            ></v-text-field>
          </v-col>
          <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-app-bar>
      </div>
      <!-- 聊天框页头 -->
      <div class="l_">
        <v-app-bar color="indigo darken-1" dark>
          <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
          <v-toolbar-title style="width:260px;padding-left: 8px;" v-if="items.length>0">
            <v-img
              width="40"
              height="40"
              class="thumb_url__"
              v-if="items[item_].thumb_url !== ''"
              :src="items[item_].thumb_url"
            ></v-img>
            <v-img
              width="40"
              height="40"
              class="thumb_url__"
              v-else
              src="../assets/20191028190529.png"
            ></v-img>
            <span v-if="items[item_].tag_name !== ''" style="position: relative; top: -12px; left: 5px;">{{ items[item_].tag_name }}</span>
            <span v-else style="position: relative; top: -12px; left: 5px;">{{ `${items[item_].user_name}` }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu left bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="user( items[item_] )" v-if="items.length>0">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
              <v-btn icon v-on="on" v-else>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <!-- <v-list>
              <v-list-item v-for="n in userSetting" :key="n" @click="() => {}">
                <v-list-item-title>{{ n }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </v-app-bar>
      </div>
    </v-content>

    <!-- 患者列表 -->
    <v-card class="mx-left left_" tile left_>
      <v-list :shaped="true" :avatar="true" :dense="true" :two-line="true">
        <v-subheader class="subheader_" v-if="icon__">
          <v-list-item-avatar v-if="items.length>0">
            <v-img v-if="doctorData.thumb_url !== ''" :src="doctorData.thumb_url"></v-img>
            <v-img v-else src="../assets/20191028190529.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title style="color: #000;margin-bottom: 5px;">{{ doctorData.name }} 医生</v-list-item-title>
            <v-list-item-subtitle v-if="doctorData.level == 1">主任医师</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="doctorData.level == 2">副主任医师</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="doctorData.level == 3">主治医师</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="doctorData.level == 4">住院医师</v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="doctorData.level == 5">助理医师</v-list-item-subtitle>
          </v-list-item-content>
          <v-btn icon @click="icon_( false )">
            <v-icon>add_circle_outline</v-icon>
          </v-btn>
        </v-subheader>
        <v-subheader class="subheader__" v-else>
          <v-list-item-avatar>
            <img v-if="doctorData.thumb_url !== ''" :src="doctorData.thumb_url" />
            <img v-else src="../assets/20191028190529.png" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title style="color: #000;margin-bottom: 5px;">
              <!-- <span color="indigo--text"> 今日收入（元）10.00 </span>   -->
              <v-chip
                class="ma-2"
                color="indigo"
                text-color="indigo"
                small
                outlined
                @click="()=>{ this.amount('今日收入') }"
              >
                <v-avatar left>
                  <v-icon>monetization_on</v-icon>
                </v-avatar>
                今日收入： {{ (order_income.today_amt/100).toFixed(2) }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-chip
                class="ma-2"
                color="black"
                text-color="black"
                small
                outlined
                @click="()=>{ this.amount('累计收入') }"
              >
                <v-avatar left>
                  <v-icon>security</v-icon>
                </v-avatar>
                累计收入：{{ (order_income.total_amt/100).toFixed(2) }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-btn icon @click="icon_( true )">
            <v-icon>remove_circle_outline</v-icon>
          </v-btn>
        </v-subheader>
        <!-- 患者列表 -->
        <v-list-item-group v-model="item_" color="primary">
          <template v-if="items.length > 0">
            <template v-for="(it, i) in items" >
            <v-list-item :key="i" v-show="it.show"  @click="img_( it.id )" >
            <v-list-item-avatar>
              <!-- 徽标 -->
              <v-badge v-model="it.messageStatus" color="purple" >
                <template v-slot:badge>
                  <span>{{ it.messageNumber }}</span>
                </template>
                <img  style="height: 40px; width: 40px;border-radius: 50%;" :src="it.thumb_url" />
              </v-badge>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span v-if="it.tag_name !== ''">{{ it.tag_name }} -</span>
                {{ it.user_name }}
              </v-list-item-title>
              <v-list-item-subtitle class="brown--text darken-2 ">{{ it.messageText }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ it.update_time | time }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          </template>
          </template>
          <template v-else>
            <div style="margin: 31px auto;text-align: center;color: #aaa;">
              暂无患者咨询...
            </div>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>

    <!-- 聊天框 -->
    <v-card class="mx-left right_" tile left_>
      <div class="right_body" v-if="items.length>0">
        <v-btn color="grey" icon text @click="loadMore"  style="margin: 0 auto; display: block;" > <v-icon>keyboard_capslock</v-icon> </v-btn>
        <template v-for="(item, index) in massageList">
          <div :key="index">
            <!-- 用户消息 -->
            <div v-if="item.from == items[item_].id">
              <v-avatar class="img_" width="40" height="40" >
                <img  class="thumb_url__" v-if="items[item_].thumb_url !== ''" :src="items[item_].thumb_url" />
                <img  class="thumb_url__" v-else src="../assets/20191028190529.png" />
              </v-avatar>
              <!-- 文字 -->
              <div class="text_ indigo lighten-5" v-if="item.type == 0">{{ item.content[0].text }}</div>
              <!-- 语音 -->
              <div class="text_" v-else-if="item.type == 2">
                <Audio :message="item.content[0].url" :time="item.content[0].duration" ></Audio>
              </div>
              <!-- 图片 -->
              <div class="text_" v-else-if="item.type == 1">
                <!-- <template v-for="(img, index) in item.content">
                  <div :key="index">
                    <img class="massageList_img" :src="img.thumb_url" alt="loading..." /> -->
                    <v-col v-for="(img, index) in item.content" :key="index" >
                        <v-card>
                          <v-img
                            :src="img.thumb_url"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            @dblclick="bigImage(img.url)"
                          >
                            <v-card-title v-text="`${img.width}*${ img.height }`"></v-card-title>
                          </v-img>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="imagesHortcut(img.url)">
                              <v-icon  >image_search</v-icon>
                            </v-btn>
                            <v-btn icon @click="bigImage(img.url)">
                              <v-icon >aspect_ratio</v-icon>
                            </v-btn>
                            <v-btn icon @click="downloadIamge( img.thumb_url, 'hisens' )">
                              <v-icon  >cloud_download</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                  <!-- </div>
                </template> -->
              </div>
              <!-- 首条消息 -->
              <div class="text_" v-else-if="item.type == 3">
                <v-card max-width="450" class="mx-auto">
                  <v-list-item>
                    <v-list-item-avatar color="grey" v-if="items.length>0">
                      <v-img
                        width="40"
                        height="40"
                        class="thumb_url__"
                        v-if="items[item_].thumb_url !== ''"
                        :src="items[item_].thumb_url"
                      ></v-img>
                      <v-img
                        width="40"
                        height="40"
                        class="thumb_url__"
                        v-else
                        src="../assets/20191028190529.png"
                      ></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="headline"> {{ items[item_].user_name }} </v-list-item-title>
                      <v-list-item-subtitle>{{ item.create_time | time }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" height="194"></v-img> -->
                  <!-- 无缝轮播 -->
                  <template v-if="item.content.length > 1" >
                  <v-carousel
                    height="300"
                    delimiter-icon="mdi-minus"
                    v-model="carousel_index"
                    >
                      <template v-for="(color, i) in item.content">
                        <v-carousel-item  :key="i" v-if="color.thumb_url !== ''">
                          <v-sheet height="100%" tile>
                            <v-row class="fill-height" align="center" justify="center" >
                              <div class="display-3" style="width:450px;text-align: center;" >
                                <img :src="color.thumb_url" alt="" srcset="">
                              </div>
                            </v-row>
                          </v-sheet>
                        </v-carousel-item>
                      </template>
                  </v-carousel>
                  </template>
                  <template v-for="(color, i) in item.content">
                    <v-card-text :key="i" v-if="color.thumb_url == ''" class="black--text" >{{ color.text }}</v-card-text>
                  </template>
                  <v-card-actions>
                    <!-- <v-btn text color="deep-purple accent-4">患者档案</v-btn> -->
                    <v-spacer></v-spacer>
                    <v-btn icon v-if="item.content.length > 1" @click="bigImage( item.content[carousel_index].url)">
                      <v-icon>aspect_ratio</v-icon>
                    </v-btn>
                    <v-btn icon v-if="item.content.length > 1" @click="carousels( item.content )">
                      <v-icon>image_search</v-icon>
                    </v-btn>
                    <v-btn icon v-if="item.content.length > 1" @click="downloadIamge( item.content[carousel_index].thumb_url, 'hisens' )">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </div>

            <!-- 医生消息 -->
            <div v-if="item.from == doctorData.doctor_id" style="text-align: right;">
              <v-avatar class="img__" width="40" height="40">
                <img width="40" height="40" v-if="doctorData.thumb_url !== ''" :src="doctorData.thumb_url" />
                <img width="40" height="40" v-else src="../assets/20191028190529.png" />
              </v-avatar>
              <!-- 文字 -->
              <div class="text__" v-if="item.type == 0">{{ item.content[0].text }}</div>
              <!-- 语音 -->
              <div class="text_" v-else-if="item.type == 2">
                <Audio :message="item.content[0].url" ></Audio>
              </div>
              <!-- 图片 -->
              <div class="text_" v-else-if="item.type == 1">
                    <v-col v-for="(img, index) in item.content" :key="index" >
                        <v-card>
                          <v-img
                            :src="img.thumb_url"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            @dblclick="bigImage(img.url)"
                          >
                            <v-card-title v-text="`${img.width}*${ img.height }`"></v-card-title>
                          </v-img>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="imagesHortcut(img.url)">
                              <v-icon  >image_search</v-icon>
                            </v-btn>
                            <v-btn icon @click="bigImage(img.url)">
                              <v-icon >aspect_ratio</v-icon>
                            </v-btn>
                            <v-btn icon @click="downloadIamge( img.thumb_url, 'hisens' )">
                              <v-icon  >cloud_download</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 输入框 -->
      <v-col cols="12" md="12" v-if="items.length>0">
        <v-textarea
          outlined
          name="input-7-4"
          :label="`发送给 ${items[item_].user_name} 患者`"
          color="black"
          :no-resize="true"
          v-model.trim="valueText"
          @keyup.ctrl.enter="sendText"
        ></v-textarea>
      </v-col>
      <!-- 操作按钮 -->
      <div class="text-left button_" v-if="items.length>0">
        <!-- <v-btn-toggle
          v-model="toggle_multiple"
          dense
          background-color="black"
          dark
          class="btn-toggle_"
        > -->
          <!-- <v-btn @click="imgageBtn" >
            <v-icon>perm_media</v-icon>
          </v-btn> -->
          <v-btn text icon color="pink" @click="imgageBtn">
            <input type="file" name="" accept="image/*" hidden multiple id="imgageList" @change="upImage">
              <v-icon>panorama</v-icon>
          </v-btn>
          <!-- emoji -->
          <Emoji></Emoji>
          <!-- 快捷回复 -->
          <Quick></Quick>
        <v-btn
          :loading="loader"
          class="ma-2"
          tile
          color="indigo submit_"
          dark
          @click="sendText"
        >发送(ctrl+Enter)</v-btn>
      </div>
      <p v-else style="margin: 100px auto;text-align: center;color: #aaa;" >暂无咨询记录...</p>
    </v-card>
    <!-- 个人中心 -->
    <PersonalCenter ref="Personal"></PersonalCenter>
    <!-- 发起提现 -->
    <Withdraw ref="Withdraw"></Withdraw>
    <!-- 设置问诊金额 -->
    <Amount ref="Amount"></Amount>
    <!-- 意见反馈 -->
    <Feedback ref="Feedback"></Feedback>
    <!-- 关于我们 -->
    <AboutUs ref="AboutUs"></AboutUs>
    <!-- 今日收入 -->
    <TodayAmount ref="TodayAmount"></TodayAmount>
    <!-- 累计收入 -->
    <CumulativeAmount ref="CumulativeAmount"></CumulativeAmount>
    <!-- 大图预览 -->
    <Image_ ref="Image_"></Image_>
    <!-- 首条消息无缝轮播图 -->
    <Carousels ref="Carousels"></Carousels>
    <!-- 退出登录 -->
    <SignOut ref="SignOut"></SignOut>
    <!-- 用户详情 -->
    <UserInfo ref="UserInfo"></UserInfo>
  </v-card>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import PersonalCenter from "@/components/home/personalCenter.vue";
import Withdraw from "@/components/home/withdraw.vue";
import Amount from "@/components/home/amount.vue";
import Feedback from "@/components/home/feedback.vue";
import AboutUs from "@/components/home/aboutUs.vue";
import TodayAmount from "@/components/home/todayAmount.vue";
import CumulativeAmount from "@/components/home/cumulativeAmount.vue";
import Image_ from '../components/home/image.vue';
import Carousels from '../components/home/carousels.vue';
import Audio from '../components/home/audio.vue';
import SignOut from '../components/home/signOut.vue';
import Websock from "../serves/websock.js";
import UserInfo from '../components/user/userInfo.vue';
import Quick from '../components/home/quick.vue';
import Emoji from '../components/home/emoji.vue'
import { setInterval } from 'timers';
export default {
  name: "home",
  components: {
    // HelloWorld
    PersonalCenter,
    Withdraw,
    Amount,
    Feedback,
    AboutUs,
    TodayAmount,
    CumulativeAmount,
    Image_,
    Carousels,
    Audio,
    SignOut,
    UserInfo,
    Quick,
    Emoji
  },
  data: () => ({
    doctorSetting: [
      {name:"个人中心",icon:'person'},
      {name:"发起提现",icon:'monetization_on'},
      {name:"问诊金额",icon:'credit_card'},
      {name:"意见反馈",icon:'rate_review'},
      {name:"关于我们",icon:'people_alt'},
      {name:"退出登录",icon:'double_arrow'}
      ],
    /* 当前轮播图位置 */
    carousel_index: 0,
    /* 医生数据 */
    doctorData: {
      doctor_id: null
    },
    value: "",
    toggle_multiple: [0, 1, 2],
    /* 侧边用户 */
    item_: 0,
    items: [
      {
        thumb_url: "",
        user_name: '',
        update_time: 1577808000
      }
    ],
    icon__: true,
    /* 收入详情 */
    order_income: {},

    /* websocket */
    path: "wss://www.hiensor.net:10443/api/v1/ws",
    websock: null,
    to_id: null,
    massageList: [],
    valueText: "",
    loader: false,
    page: 0
  }),
  mounted() {
    this.doctorInfo();
    
    setInterval(() => {
    //   this.websocketclose()
      // this.initWebSocket()
    //   this.websocketonopen()
    //   window.console.log( `this.initWebSocket()` )
    }, 15000);
    setTimeout(() => {
      this.oneMessage();
      this.initWebSocket();
    }, 2000);
    /* 快捷回复 - 已存在 */
    if( this.$cookie.getLocalStorage('Quick') == false ){
        this.$cookie.setLocalStorage( 'Quick', JSON.stringify(['您好！您可以在这里添加快捷回复文本信息。']) );
    }
  },
  methods: {
    user( item ){
      // UserInfo
      this.$refs.UserInfo.info(true, item);
    },
 
    /* 筛选框 */  
    oneList__() {
      if (this.value !== "") {
        this.items.forEach(element => {
                if( element.user_name.indexOf( `${ this.value }`) !== -1 ){
                    element.show = true;
                }else{ element.show = false; }
        });
      }else{
          this.items.forEach(element => { element.show = true; })
      }
    },
    // 记载更多消息
    loadMore(){
      window.console.log(this.page);
      this.page = this.page+1;
      this.$axios({
        method: "get",
        url: `${this.$apis.URL.message_record}?to_id=${this.to_id}&page_count=10&page=${this.page}`,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            let reverse = req.data.datas.list.reverse();
            this.massageList.splice(0,0,...reverse);
            this.animation_top();
            if( reverse.length < 10 ){ this.$Dialog.getProductCheckResult_({ text: `没有更多信息啦！`, timeout: 3000, snackbar: true }); }
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* 图片上传 */
    upImage(){
      this.loader = true;
      // message_image
      let list = document.getElementById('imgageList').files;
      window.console.log(list)
      if( list.length > 9 ){
        this.$Dialog.getProductCheckResult_({
              text: `您选择的图片过多，本次只会上传前9张哦！`,
              timeout: 15000,
              snackbar: true
        });
        list.slice(0,9)
      }
      let formData = new FormData();
      formData.append("to_user_id", this.to_id);
      formData.append("images", list);
      list.forEach(element => {
        formData.append("images", element);
      });
      this.$axios({
        method: "post",
        url: this.$apis.URL.message_image,
        data: formData
      })
        .then(req => {
          if (req.data.result == 0) {
            this.loader = false;
            this.$Dialog.getProductCheckResult_({
              text: `发送消息`,
              timeout: 3000,
              snackbar: true
            });
            let data = req.data.datas;
            let message = {
              content: [
                {
                  id: 0,
                  msg_index: data.msg_index,
                  text: '',
                  url: data.origin,
                  thumb_url: data.thumb,
                  height: data.height,
                  width: data.width,
                  duration: 0
                }
              ],
              create_time: data[0].create_time,
              to: data[0].to_user_id,
              msg_index: data[0].msg_index,
              from: data[0].from_user_id,
              type: 1
            };
            data.forEach(data => {
              message.content.push({
                id: 0,
                  msg_index: data.msg_index,
                  text: '',
                  url: data.origin,
                  thumb_url: data.thumb,
                  height: data.height,
                  width: data.width,
                  duration: 0
              })
            });
            message.content.splice(0,1);
            this.massageList.push(message);
            this.valueText = "";
            this.animation();
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },
    // 选择图片按钮
    imgageBtn(){
      document.getElementById('imgageList').click();
    },
    /* 原图捷径 */ 
    imagesHortcut( img ){
      if( img == '' ){ return }
      window.open(img,'newwindow', `height=600, width=800, top=${ document.body.clientHeight/2 - 200 }, left=${ document.body.clientWidth/2 - 400 }, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`);
    },
    /* 图片保存到本地 */ 
      downloadIamge(imgsrc, name) {
        window.console.log( imgsrc )
        var image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png");
          var a = document.createElement("a");
          var event = new MouseEvent("click");
          a.download = name || "photo";
          a.href = url;
          a.dispatchEvent(event);
        };
        image.src = imgsrc;
      },
    /* 首条消息无缝轮播图 */
    carousels( img, index ){
      this.$refs.Carousels.info(true, img, index);
    },
    /* 大图预览 */
    bigImage( img ){
      this.$refs.Image_.info(true, img);
    }, 
    /* 患者侧边列表获取首条消息 */
    oneMessage(){
      if( this.items.length == 0){ return }
      this.loader = true;
      let number_ = 0;
      let Message = ( number )=>{
        this.$axios({
        method: "get",
        url: `${this.$apis.URL.message_record}?to_id=${this.items[number].id}&page_count=1`,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            let data = req.data.datas.list[0];
            switch (data.type) {
              case 0: this.items[number].messageText = data.content[0].text; break;
              case 1: this.items[number].messageText = '【图片消息】'; break;
              case 2: this.items[number].messageText = '【语音消息】'; break;
              case 3: this.items[number].messageText = '【问诊消息】'; break;
              default: this.items[number].messageText = '【暂无消息】'; break;
            }
            window.console.log( number )
            window.console.log( this.items.length-1 )
            if( number == this.items.length-1 ){ this.loader = false; }
            if( number < this.items.length-1 ){
              Message(++number_);
            }
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true});
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
      };
      Message(number_);
    },
    /* 获取聊天信息和连接socket */
    img_(to_id) {
      // message_record
      this.to_id = to_id;
      // this.websocketonopen()
      // this.websocketclose();
      // this.initWebSocket();
      this.$axios({
        method: "get",
        url: `${this.$apis.URL.message_record}?to_id=${this.to_id}&page_count=10&page=0`,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            this.$Dialog.getProductCheckResult_({
              text: `聊天记录请求成功`,
              timeout: 3000,
              snackbar: true
            });
            let reverse = req.data.datas.list.reverse();
            this.massageList = reverse;
            this.animation();
            // 清除徽标 messageStatus
            this.items.forEach(user => {
              if( user.id == to_id ){
                user.messageStatus = false;
                user.messageNumber = 0;
              }
            });
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },
    /* 连接socket */
    initWebSocket() {
      // window.console.log(this.doctorData.doctor_id + "-----" + this.to_id);
      //初始化weosocket
      this.websock = new WebSocket(this.path);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    /* 连接建立之后执行send方法发送数据 */
    websocketonopen() {
      let actions = new Blob(
        [
          `{
              "from": ${this.doctorData.doctor_id},
              "to": ${this.to_id},
              "type": 4,
              "create_time": 0,
              "content": [{
                            "text": "",
                            "url": "",
                            "height": 0,
                            "width": 0,
                            "thumb_url": "",
                            "duration": 0
                          }]
          }`
        ],
        { type: "text/plain" }
      );
      this.websocketsend(actions);
    },
    /* 连接建立失败重连 */
    websocketonerror(event) {
      window.console.log( event )
      this.initWebSocket();
    },
    /* 数据接收 */
    websocketonmessage(e) {
      this.loader = true;
      let byteArray = new Uint8Array(e.data);
      let data = JSON.parse(Websock.utf8ByteToUnicodeStr(byteArray));
      // 设置徽标
      data.forEach(message => {
        window.console.log( message.from )
        this.items.forEach( user => {
          window.console.log( user.id )
          // 非当前窗口
          if( message.from == user.id ){
            user.messageStatus = true;
            user.messageNumber++;
            switch (message.type) {
              case 0: user.messageText = message.content[0].text; break;
              case 1: user.messageText = '【图片消息】'; break;
              case 2: user.messageText = '【语音消息】'; break;
              case 3: user.messageText = '【问诊消息】'; break;
              default: user.messageText = '【暂无消息】'; break;
            }
            this.loader = false;
          }
        } )
          // 当前窗口
          let current = this.items[this.item_];
          if( current.id == message.from ){
            current.messageStatus = false;
            current.messageNumber = 0;
            this.massageList.push(...data);
            this.animation();
            switch (message.type) {
              case 0: current.messageText = message.content[0].text; break;
              case 1: current.messageText = '【图片消息】'; break;
              case 2: current.messageText = '【语音消息】'; break;
              case 3: current.messageText = '【问诊消息】'; break;
              default: current.messageText = '【暂无消息】'; break;
            }
          }
      });
      // window.console.log( this.items[this.item_].id)
      // window.console.log( data)
    },
    /* 数据发送 */
    websocketsend(Data) {
      this.websock.binaryType = "arraybuffer";
      this.websock.send(Data);
    },
    /* 关闭 */
    websocketclose(e) {
      this.$Dialog.getProductCheckResult_({
        text: `连接断开${ JSON.stringify(e) }`,
        timeout: 100000,
        snackbar: true
      });
        window.console.log( JSON.stringify(e) );
        setInterval(()=>{ this.initWebSocket(); },10000);
    },
    /* emoji */ 
    quick_emoji(text){
      this.valueText += text;
    },
    /* 快捷回复 */ 
    quick(text){
      this.valueText = text;
      this.sendText();
    },
    /* 发送文本 */
    sendText() {
      // message_text
      if (this.valueText == "") {
        this.$Dialog.getProductCheckResult_({
          text: `内容不能为空哦！`,
          timeout: 3000,
          snackbar: true
        });
        return false;
      }
      this.loader = true;
      this.$axios({
        method: "post",
        url: this.$apis.URL.message_text,
        data: {
          text: `${this.valueText}`,
          to_user_id: this.to_id
        }
      })
        .then(req => {
          if (req.data.result == 0) {
            this.loader = false;
            this.$Dialog.getProductCheckResult_({
              text: `发送消息`,
              timeout: 3000,
              snackbar: true
            });
            let data = req.data.datas;
            let message = {
              content: [
                {
                  id: 0,
                  msg_index: data.msg_index,
                  text: data.text,
                  url: "",
                  thumb_url: "",
                  height: 0,
                  width: 0,
                  duration: 0
                }
              ],
              create_time: data.create_time,
              to: data.to_user_id,
              msg_index: data.msg_index,
              from: data.from_user_id,
              type: 0
            };
            this.massageList.push(message);
            this.valueText = "";
            window.console.log(message);
            this.animation();
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },
    /* 消息动画 - bottom */
    animation() {
      setTimeout(() => {
        document
          .getElementsByClassName("right_body")[0]
          .scrollTo({
            top: document.getElementsByClassName("right_body")[0].scrollHeight,
            behavior: "smooth"
          });
      }, 50);
    },
    /* 消息动画 - top */
    animation_top() {
      setTimeout(() => {
        document
          .getElementsByClassName("right_body")[0]
          .scrollTo({
            top: 0,
            behavior: "smooth"
          });
      }, 50);
    },
    // socket
    socket() {},
    /* 弹出框 */
    amount(text) {
      if (text == "今日收入") {
        this.$refs.TodayAmount.info(true, this.order_income);
      }
      if (text == "累计收入") {
        this.$refs.CumulativeAmount.info(true, this.order_income);
      }
    },
    /* 获取收入明细 */
    icon_(item) {
      this.icon__ = item;
      if (!item) {
        // api/v1/order/income_amount
        this.$axios({
          method: "get",
          url: this.$apis.URL.order_income_amount,
          data: {}
        })
          .then(req => {
            if (req.data.result == 0) {
              this.$Dialog.getProductCheckResult_({
                text: `医生个人收入请求成功`,
                timeout: 3000,
                snackbar: true
              });
              this.order_income = req.data.datas;
              window.console.log(this.doctorData);
            } else {
              this.$Dialog.getProductCheckResult_({
                text: req.data.message,
                timeout: 3000,
                snackbar: true
              });
            }
          })
          .catch(error => {
            this.$Dialog.getProductCheckResult_({
              text: error,
              timeout: 3000,
              snackbar: true
            });
          });
      }
    },
    /* 医生菜单 */
    doctor(text) {
      window.console.log(text);
      switch (text) {
        case "个人中心": this.$refs.Personal.info(true, this.doctorData); break;
        case "发起提现": this.$refs.Withdraw.info(true, this.doctorData); break;
        case "问诊金额": this.$refs.Amount.info(true, this.doctorData); break;
        case "意见反馈": this.$refs.Feedback.info(true); break;
        case "关于我们": this.$refs.AboutUs.info(true); break;
        case "退出登录": this.$refs.SignOut.info(true); break;
        default: break;
      }
    },
    // 医生信息
    doctorInfo() {
      // doctor_info
      this.$axios({
        method: "get",
        url: this.$apis.URL.doctor_info,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            this.$Dialog.getProductCheckResult_({
              text: `医生个人信息请求成功`,
              timeout: 3000,
              snackbar: true
            });
            this.doctorData = req.data.datas;
            this.userList();
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },

    /* 获取患者列表 */ 
    userList() {
      // user_chat_trails
      this.$axios({
        method: "get",
        url: this.$apis.URL.user_chat_trails,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            if( req.data.datas.length == 0 ){
              this.items = [];
              return false;
            }else{
              this.$Dialog.getProductCheckResult_({ text: `咨询记录列表请求成功`, timeout: 3000, snackbar: true });
              this.items = req.data.datas;
              this.items.forEach(user => {
                user.messageStatus = false;
                user.messageNumber = 0;
                user.messageText = '消息收取中...';
                user.show = true;
              });
                this.to_id = this.items[0].id;
                this.img_(this.to_id);
                window.console.log(this.items);
          }
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    }
  }
};
</script>
<style>
.subheader__ .theme--light.v-chip {
  margin: 0px !important;
}
</style>
<style lang="scss" scoped>
.home {
  min-width: 880px;
  max-width: 1150px;
  margin: 0px auto;
  margin-bottom: 0;
  height: 800px;
  margin-top: calc( (50% - 800px)/2 );
  opacity: 0.92;
  // vertical-align: middle;
  // display: flex;
  // align-items: center; /*定义body的元素垂直居中*/
  // justify-content: center; /*定义body的里的元素水平居中*/

  .v-content__wrap {
    > div {
      display: inline-block;
    }
  }
  .l_ {
    width: 70%;
    .thumb_url__ {
      border-radius: 50%;
      display: inline-block;
      margin-top: 10px;
    }
  }
  .r_ {
    width: 30%;
  }
  .input_ {
    padding: 0;
    height: 39px;
    padding-left: 13px;
  }
  .left_ {
    max-width: 345px;
    display: inline-block;
    width: 30%;
    margin-top: -6px;
    height: calc(100% - 65px);
    .v-item-group {
      height: 660px;
      overflow-y: auto;
    }
    .theme--light.v-list {
      padding: 0;
    }
  }
  .right_ {
    display: inline-block;
    width: 70%;
    margin-top: -6px;
    height: calc(100% - 65px);
    float: right;
    .right_body {
      height: 550px;
      width: 100%;
      // border: solid 1px #000;
      padding: 5px 15px;
      overflow-y: auto;
      > div {
        // border: solid 1px red;
        margin: 10px;
        margin-bottom: 20px;
        display: block;
        transition: all 0.3s;
      }
    }
    .button_ {
      position: relative;
      top: -45px;
      margin-right: 5px;
      >button{
        margin: 12px;
      }
    }
    .btn-toggle_ {
      margin: 13px;
      margin-bottom: 0;
    }
    .submit_ {
      float: right;
      margin-top: 13px !important;
      width: 170px;
    }
    .text_ {
      display: inline-block;
      max-width: 60%;
      // border: solid 1px darkcyan;
      padding: 7px 20px;
      margin-left: 10px;
      border-radius: 15px;
      border-top-left-radius: 0px;
      // background-color: #e3f2fd;
      position: relative;
      top: 10px;
      .massageList_img {
        max-width: 200px;
        max-height: 200px;
      }
    }
    .img_ {
      float: left;
      max-width: 40px !important;
      min-width: 35px !important;
    }
    .text__ {
      display: inline-block;
      background-color: #e8f5e9;
      max-width: 60%;
      padding: 7px 20px;
      border-radius: 15px;
      border-top-right-radius: 0px;
      margin-left: calc(40% - 60px);
      margin-right: 10px;
      position: relative;
      top: 10px;
      .massageList_img {
        max-width: 200px;
        max-height: 200px;
      }
    }
    .img__ {
      float: right;
      max-width: 40px !important;
      min-width: 35px !important;
    }
  }
  .subheader_,
  .subheader__ {
    height: 72px;
    margin-left: 8px;
    border-bottom: solid 1px #f1f1f1;
    //  cursor:pointer;
  }
}

.right_body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.right_body::-webkit-scrollbar-thumb,
.v-item-group::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.6);
  height: 120px;
}

.right_body::-webkit-scrollbar-track,
.v-item-group::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
}

.right_body::-webkit-scrollbar,
.v-item-group::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.right_body::-webkit-scrollbar-thumb,
.v-item-group::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.2);
  height: 120px;
}

.right_body::-webkit-scrollbar-track,
.v-item-group::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 2px;
  background: #fff;
}
</style>

